define('plugin/product/view/ProductBookingDetailsView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Product cart on booking details view
     *
     * @class ProductBookingDetailsView
     */
    return LayoutView.extend({

        template: '#product_booking_details_view',

        modelEvents: {
            'sync': 'render'
        },

        serializeData: function () {
            var items = this.model.get('items');
            var tax = this.model.getTax();
            var total = this.model.getTotal();

            return _.extend(LayoutView.prototype.serializeData.apply(this, arguments), {
                items: items ? items.toJSON() : [],
                empty: this.model.isEmpty(),
                tax: tax,
                total: Config.getInstance().getOption('price_includes_tax') ? total : total + tax,
                currency: this.model.getCurrency()
            });
        }

    });

});
